import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function HomeLatest() {
  const latest = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">
              最新攻略文章
            </h2>
            <p className="text-sm text-foreground-600">
              持续更新撸啊撸版本强势英雄攻略与上分技巧
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 no-underline cursor-pointer"
            >
              <div className="w-20 h-20 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.thumb}
                  alt={article.title}
                  className="w-full h-full object-cover object-top"
                  title={article.title}
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1 mb-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}分钟
                  </span>
                  <span>{article.publishDate}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}